import gsap from 'gsap';
import Swiper from 'swiper/bundle';
import changeSliderBg from './change-slider-bg';
import Plyr from 'plyr';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { isDesktop, isMobile, isTablet } from './exportFunc';


export default () =>{
    gsap.registerPlugin(ScrollTrigger);
    const SPEED = 1500;
    const AUTOPLAYSPEED = 10000;
    function pag(wrapper){
        if (!wrapper){
            return false
        } else {
            return {
            
                el: wrapper,
                clickable: true,
                currentClass: 'default-pagination--current',
                totalClass: 'default-pagination--total',
                
                type: "fraction",
                renderFraction: function (currentClass, totalClass, index) {
                    return '<span class="' + currentClass + '"></span>' +
                            
                            '<span class="' + totalClass + '"></span>';
                },
                formatFractionTotal:  function (index) {
                    if(index < 10) {
                        return  '0' + index; 
                    } else {
                        return index; 
                    }
                    
                },
                formatFractionCurrent:  function (index) {
                    if(index < 10) {
                        return  '0' + index; 
                    } else {
                        return index; 
                    }
                },
            }
        }
        
    }

    function paginationClass(swiperWrapper, currentSwiper){
        let curPag = swiperWrapper.querySelector('.default-pagination--current');
        setActivepagination();
        currentSwiper.on('autoplayStart'), ()=>{
            setActivepagination()
        }
        currentSwiper.on('touchEnd', function () {
            setActivepagination()
        });
        currentSwiper.on('slideChange', function () {
            setActivepagination()
        });

        function setActivepagination(){
            curPag.classList.remove('active');
            setTimeout(() => {
                curPag.classList.add('active');
            }, 100);
        }
    }

    function startAutoplay(swiper, slider){
        swiper.autoplay.stop();
        const timeLine = gsap.timeline({
            scrollTrigger: {
                trigger: slider,
                start: "top center",
            },
        })
        
        timeLine.to(slider, {
            onStart:()=>{
                swiper.autoplay.start();
                paginationClass(slider, swiper);
            }
        })
    }

    function nextHandler(nextBtns, swiper) {
        nextBtns.forEach(nextBtn =>{
            nextBtn.addEventListener("click", function () {
                swiper.slideNext();
            })
        })
    }

    changeSliderBg();

    //#region POCTCARD TYPE1
        let allowLoop = false;
        class CustomSwiper {
            constructor() {
                this.currentTransitionSpeed = 0;
                this.init();
            }

            getTransitionSpeed() {
                const transitionSpeed = this.currentTransitionSpeed;
                this.currentTransitionSpeed = 0;
                return transitionSpeed;
            }

            getActiveIndexBeforeTransitionStart(swiper, slides) {
                const isDragging = !Math.abs(slides[swiper.activeIndex].progress === 1);
                if (isDragging) {
                    return swiper.slidesGrid.indexOf(
                        -swiper.touchEventsData.startTranslate || swiper.params.initialSlide
                    );
                } else {
                    return swiper.activeIndex;
                }
            }

            getDirection(animationProgress) {
                if (animationProgress === 0) {
                    return "NONE";
                } else if (animationProgress > 0) {
                    return "NEXT";
                } else {
                    return "BACK";
                }
            }

            setTransition(swiper, transitionSpeed) {
                this.currentTransitionSpeed = transitionSpeed;
            }

            setTranslate(swiper, wrapperTranslate) {
                const durationInSeconds = this.getTransitionSpeed() / 1000;
                const slides = Object.values(swiper.slides);
                const originIndex = this.getActiveIndexBeforeTransitionStart(
                    swiper,
                    slides
                );
                    

                

                if (swiper.progress < 0) {

                    if (allowLoop) {
                        
                        setTimeout(function () {
                            swiper.el.classList.remove('notouch');
                        }, 1000);

                        swiper.el.classList.add('notouch');
                        swiper.slideTo(4, 500);

                        setTimeout(function () {
                            if (allowLoop) {
                                prevBtn.click();
                            }
                            allowLoop = false;
                        }, 1);

                       
                    }
               
                }


                // get information about animation progress from the active slide - the active slide's value is always -1 to 1.
                /*
                every slide has a progress attribute equal to the "distance" from the current active index.
                */
                const animationProgress = slides[originIndex].progress;
                const direction = this.getDirection(animationProgress);
                
                
                slides.map((slide, index) => {
                    slide.classList.remove("is-front");
                    if (Math.abs(slide.progress) == 0) {
                        slide.classList.add("is-front");    
                    }  
                    
                    let img = slide.querySelector('img');
                
                });
            }
            init() {
                const wrap = document.querySelector('.slider_type1');
                const pagination = wrap.querySelector('.default-slider__pagination');
                const that = this;
                this.swiper = new Swiper(wrap, {
                    wrapperClass: "swiper-wrapper",
                    slideClass: "postcard__card",
                    slideActiveClass: "is-active",
                    speed: SPEED,
                    centeredSlides: true,
                    autoplay: {
                        delay: AUTOPLAYSPEED,
                        autoplayDisableOnInteraction: false,
                        disableOnInteraction: false,
                    },
                    navigation: {
                        nextEl:  '.img-box',
                    },
                    breakpoints: {
                        0: {
                            slidesPerView: 'auto',
                            spaceBetween: 14,
                            effect: "slide",
                            allowTouchMove: true,
                            virtualTranslate: false,
                            watchSlidesProgress: false,
                        },
                        768: {

                            slidesPerView: 1,
                            effect: "cardTransition",
                            spaceBetween: 0,
                            virtualTranslate: true,
                        },
                    },

                    resistanceRatio: 0,
                    loop: false,
                    watchSlidesVisibility: true,
                    autoplayDisableOnInteraction: false,
                    pauseOnMouseEnter: false,
                    pagination: pag(pagination),

                    // animation related
                    watchSlidesProgress: true,
                    
                    on: {
                        progress(progress) {
                            const swiper = this;
                            if (swiper.params.effect !== "cardTransition") return;
                        },
                        setTransition(transition) {
                            const swiper = this;
                            if (swiper.params.effect !== "cardTransition") return;
                            that.setTransition(swiper, transition);
                        },
                        setTranslate(translate) {
                            const swiper = this;
                            if (swiper.params.effect !== "cardTransition") return;
                            that.setTranslate(swiper, translate);
                        },

                    },

                });

                const nextButtons = document.querySelectorAll(".postcard__card--inner .img-box");

                if (!isMobile()){
                    nextButtons.forEach( nextBtn =>{
                        nextBtn.addEventListener("click", function () {
                            let next = that.swiper.activeIndex +1;
                            if (next > 2) {
                                next = 0;
                            }
                            that.swiper.slideTo(next);
                        })
                    })
                }
                
                let curPag = document.querySelector('.default-pagination--current');
                setActivepagination();

                this.swiper.on('touchEnd', function () {
                    setActivepagination()
                });
                this.swiper.autoplay.stop();
                const timeLine = gsap.timeline({
                    scrollTrigger: {
                        trigger: wrap,
                        start: "top center",
                    },
                })
                
                timeLine.to(wrap, {
                    onStart:()=>{
                        this.swiper.autoplay.start();
                        setActivepagination();
                    }
                })

                function setActivepagination(){
                    curPag.classList.remove('active');
                    setTimeout(() => {
                        curPag.classList.add('active');
                    }, 1);
                }
            }
        }
        
        const type1 = document.querySelector('.slider_type1');
        type1?new CustomSwiper():false;

    //#endregion
    
    //#region FULL-WIDTH SLIDER
        const fwSliders = document.querySelectorAll('[slider-fw]');
        
        fwSliders.forEach(slider =>{
            const pagination = slider.querySelector('.default-slider__pagination');
            let swiper = new Swiper(slider, {
                slidesPerView: 'auto',
                spaceBetween: 65,
                centeredSlides: true,
                loop: true,
                speed: SPEED,
                autoplay: {
                    delay: AUTOPLAYSPEED,
                    autoplayDisableOnInteraction: false,
                    disableOnInteraction: false,
                },
                navigation: {
                    nextEl: '[next-el]',
                    prevEl: '[prev-el]',
                },
                touchStartPreventDefault: false,
                watchSlidesVisibility: true,
                pagination: pag(pagination),
                watchSlidesProgress: false,
                parallax: true,
                breakpoints: {
                    0: {
                        spaceBetween: 14,
                    },
                    768: {
                        spaceBetween: 60,
                    },
                    1025: {
                        spaceBetween: 65,
                    },
                },
            });

            startAutoplay(swiper, slider);
            
        })
    //#endregion

    //#region PEOPLE SLIDER
        const pplSliders = document.querySelectorAll('[slider-people]');
        
        pplSliders.forEach(slider =>{
            const pagination = slider.querySelector('.default-slider__pagination');
            const nextBtns = slider.querySelectorAll('[people-next]')
            let swiper = new Swiper(slider, {
                slidesPerView: 1,       
                speed: SPEED,
                simulateTouch: false,
                autoplay: {
                    delay: AUTOPLAYSPEED,
                    autoplayDisableOnInteraction: false,
                    disableOnInteraction: false,
                },
                touchStartPreventDefault: false,
                watchSlidesVisibility: true,
                pagination: pag(pagination),
                watchSlidesProgress: false,
                parallax: true,
                loop:true,
                navigation: {
                    nextEl: '[people-next]',
                    prevEl: '[people-prev]'
                },
                on: {
                    init(swiper){
                        if (isTablet()){
                            let a=0;
                            slider.querySelectorAll('.item').forEach(el =>{
                                el.offsetHeight > a?a=el.offsetHeight:false;
                            })
                            slider.querySelectorAll('.item').forEach(el =>{
                                el.style.height = a + 'px';
                            })      
                        }              
                    }
                }
            });
            startAutoplay(swiper, slider);
            
        })
    //#endregion

    //#region ONLY ONE IMAGE SLIDER
        const imgSliders = document.querySelectorAll('[slider-img]');
        
        imgSliders.forEach(slider =>{
            
            const pagination = slider.querySelector('.default-slider__pagination');
            const nextBtns = slider.querySelectorAll('[next-img]')
            let sw = new Swiper(slider, {
                slidesPerView: 1,       
                speed: SPEED,
                effect: 'slide',
                simulateTouch: false,
                autoplay: {
                    delay: AUTOPLAYSPEED,
                    autoplayDisableOnInteraction: false,
                    disableOnInteraction: false,
                },
                touchStartPreventDefault: false,
                watchSlidesVisibility: true,
                pagination: pag(pagination),
                watchSlidesProgress: false,

                breakpoints: {
                    0: {
                        slidesPerView: 1.17, 
                        spaceBetween: 14,
                        centeredSlides: true,
                        loop: true
                    },
                    768: {
                        slidesPerView: 1,
                        spaceBetween: 0,
                        centeredSlides: false,
                        loop: false
                    },
                },
            });
            nextBtns.forEach(nextBtn =>{
                nextBtn.addEventListener("click", function () {
                    let next = sw.activeIndex + 1;
                    if (next == sw.slides.length) {
                        next = 0;
                    }
                    sw.slideTo(next);
                })
            })
            startAutoplay(sw, slider);
        })
    //#endregion

    //#region ONLY ONE IMAGE SLIDER (home page)
        const imgSliders2 = document.querySelectorAll('[slider-img-home]');
            
        imgSliders2.forEach(slider =>{
            
            const pagination = slider.querySelector('.default-slider__pagination');
            let sw = new Swiper(slider, {
                slidesPerView: 1,       
                speed: 1500,
                effect: 'slide',
                simulateTouch: false,
                autoplay: {
                    delay: 10000,
                    autoplayDisableOnInteraction: false,
                    disableOnInteraction: false,
                },
                touchStartPreventDefault: false,
                watchSlidesVisibility: true,
                pagination: pag(pagination),
                watchSlidesProgress: false,
                parallax: true,
                navigation: {
                    nextEl: '[next-img]',
                    prevEl: '[prev-img]',
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1.17, 
                        spaceBetween: 14,
                        centeredSlides: true,
                        loop: true,
                    },
                    768: {
                        slidesPerView: 1.55,
                        spaceBetween: 80,
                        centeredSlides: true,
                        loop: true,
                        allowTouchMove: true
                    },
                    1025: {
                        slidesPerView: 1,
                        spaceBetween: 30,
                        centeredSlides: false,
                        loop:true,
                        allowTouchMove: false
                    },
                },
            });
            startAutoplay(sw, slider);
            slider.querySelectorAll('[data-stop-propogation]').forEach(el =>{
                el.addEventListener('click', (e)=>{
                    e.stopImmediatePropagation();
                })
            })
        })
    //#endregion

    //#region POSTCARD TYPE 2
        const sliderType2 = document.querySelectorAll('.slider_type2')

        sliderType2.forEach(slider =>{
            const pagination = slider.querySelector('.default-slider__pagination');
            let sw = new Swiper(slider, {
                slidesPerView: 2,       
                speed: SPEED,
                effect: 'slide',
                simulateTouch: true,
                spaceBetween: 23,
                autoplay: {
                    delay: AUTOPLAYSPEED,
                    autoplayDisableOnInteraction: false,
                    disableOnInteraction: false,
                },
                touchStartPreventDefault: false,
                watchSlidesVisibility: true,
            
                pagination: pag(pagination),

                // animation related
                watchSlidesProgress: false,
                loop: true,
                breakpoints: {
                    0: {
                        slidesPerView: 1,
                    },
                    768: {
                        spaceBetween: 27,
                        slidesPerView: 1, 
                        slidesPerColumn: 2,
                        slidesPerColumnFill: 'row',
                        loop: false,
                        centeredSlides: true
                    },
                    1025: {
                        spaceBetween: 23,
                        slidesPerView: 2,
                        slidesPerColumn: 1,
                    },
                },
            });
            paginationClass(slider, sw)
        })

    //#endregion

    //#region POSTCARD TYPE 3
        const sliderType3 = document.querySelectorAll('.slider_type3')

        sliderType3.forEach(slider =>{
            const nextBtns = slider.querySelectorAll('[postcard-next]')
            let sw = new Swiper(slider, {
                slidesPerView: 1,       
                speed: SPEED,
                effect: 'slide',
                autoplay: {
                    delay: AUTOPLAYSPEED,
                },
            });
           
            nextBtns.forEach(nextBtn => {
                nextBtn.addEventListener("click", function () {
                    let next = sw.activeIndex + 1;
          
                    if (next > sw.slides.length - 1) {
                        next = 0;
                    }
              
                    sw.slideTo(next);
                })
            })
           
            
        })
    //#endregion

    //#region POSTCARD TYPE 4
        const type4 = document.querySelectorAll('.slider_type4');
        
        type4.forEach(slider =>{
            const pagination = slider.querySelector('.default-slider__pagination');
            let swiper = new Swiper(slider, {
                slidesPerView: 'auto',       
                spaceBetween: 72,
                effect: 'slide',
                centeredSlides: true,
                allowTouchMove:false,
                simulateTouch: false,
                loop: true,
                speed: SPEED,
                
                navigation: {
                    nextEl: '[data-next]',
                    prevEl: '[data-prev]',
                },
                autoplay: {
                    delay: AUTOPLAYSPEED,
                    autoplayDisableOnInteraction: false,
                    disableOnInteraction: false,
                },
                
                touchStartPreventDefault: false,
                watchSlidesVisibility: true,
                pagination: pag(pagination),
                watchSlidesProgress: true,
                on: {
                    setTransition(swiper, transition) {
                        if (isMobile()) {
                            return
                        }
                        setTransition(swiper, transition);
                    },
                    setTranslate(swiper, translate) {
                        if (isMobile()) {
                            return
                        }
                        setTranslate(this, translate);
                    },
                },

                breakpoints: {
                    0: {
                        spaceBetween: 14,
                        allowTouchMove: true,
                    },
                    768: {
                        spaceBetween: 23,
                        allowTouchMove: true,
                    },
                    1025: {
                        spaceBetween: 50,
                        allowTouchMove:false,
                    },
                    1281: {
                        spaceBetween: 78,
                        allowTouchMove:false,
                    },
                },
            });

            paginationClass(slider, swiper);

            let currentTransitionSpeed = 0, rotateInSeconds = 0;

            function setTransition(swiper, transitionSpeed) {
                currentTransitionSpeed = transitionSpeed;
            }

            function getTransitionSpeed() {
                const transitionSpeed = currentTransitionSpeed;
                currentTransitionSpeed = 0;
                return transitionSpeed;
            }

            
            function setTranslate(swiper, wrapperTranslate) {
                rotateInSeconds = getTransitionSpeed() / 1000;
                let transformOrigin;
                const slides = Object.values(swiper.slides);
                slides.map((slide, index) => {
                    let i, sideRotate, delimetr;
                    isTablet()?sideRotate = 5:sideRotate = 15
                    let rotationZ = 0;

                    let progress = slide.progress;
                    slide.setAttribute('progress', progress)
                    rotationZ = -progress * sideRotate;                   
                    progress >0?transformOrigin = 'bottom right':transformOrigin = 'bottom left';
                    // Math.abs(progress) == 1?i=10:i=80
                    if (Math.abs(progress) == 1){i=72}
                    else if(Math.abs(progress) == 2){i=72*2}
                    else if(Math.abs(progress) == 3){i=160}
                    isTablet()?delimetr = Math.abs(progress):delimetr = Math.abs(progress)*i;
                    gsap.to(slide, {
                        rotate: rotationZ,
                        y: delimetr,
                        duration: rotateInSeconds,
                    });
                    
                });
            }

           
        })

    //#endregion

    //#region POSTCARD TYPE 5
        const sliderType5 = document.querySelector('.slider_type5')

        sliderType5? slider5handle():false;

        let sw5;

        function slider5handle() {
            const nextBtns = sliderType5.querySelectorAll('[next-el]');
            const prevBtns = sliderType5.querySelectorAll('[prev-el]');
            const pagination = sliderType5.querySelector('.default-slider__pagination');
            sw5 = new Swiper(sliderType5, {
                slidesPerView: 'auto',       
                speed: SPEED,
                simulateTouch: true,
               
                autoplay: {
                    delay: AUTOPLAYSPEED,
                    autoplayDisableOnInteraction: false,
                    disableOnInteraction: false,
                },
                breakpoints: {
                    0: {
                        virtualTranslate : false,
                        effect: 'slide',
                        spaceBetween: 14,
                        centeredSlides: true,
                        allowTouchMove: true
                    },
                    1024: {
                        allowTouchMove: false,
                    }
                },
                virtualTranslate : true,
                touchStartPreventDefault: false,
                watchSlidesVisibility: true,
                pagination: pag(pagination),
                watchSlidesProgress: false,
                
            });
            nextBtns.forEach(nextBtn =>{
                nextBtn.addEventListener("click", function () {
                    let next = sw5.activeIndex + 1;
                    if (next > sw5.slides.length - 1) {
                        next = 0;
                    }
                    sw5.slideTo(next);
                })
            })
            prevBtns.forEach(prevBtn =>{
                prevBtn.addEventListener("click", function () {
                    let prev = sw5.activeIndex - 1;
                    if (prev == -1) {
                        prev = sw5.slides.length -1;
                    }
                    sw5.slideTo(prev);
                })
            })
            startAutoplay(sw5, sliderType5);
        }

        
        
    //#endregion

    //#region POSTCARD TYPE 6
    const sliderType6 = document.querySelector('.slider_type6')
   
    sliderType6? slider6handle():false;

    function slider6handle() {
        let sw6 = new Swiper(sliderType6, {
            slidesPerView: 1,  
            effect: 'slide',     
            speed: SPEED,
            simulateTouch: false,
            touchStartPreventDefault: false,
            watchSlidesVisibility: true,
            parallax: true,
            loop: false
        });
       

        sw5.controller.control = sw6;
        sw6.controller.control = sw5;
    }

   
 //#endregion

    //#region CASITA BOTTOM SLIDER
        const casitaBottomWrapper = document.querySelectorAll('[casita-bottom-slider]');
        casitaBottomWrapper.forEach(el =>{
            const slider = el.querySelector('[casita-bottom-slider-right]');
            const casitaBottomSliderLeft = el.querySelector('[casita-bottom-slider-left]');
            let left = new Swiper(casitaBottomSliderLeft, {
                effect: 'fade',
                speed: SPEED,
                fadeEffect: {
                    crossFade: true
                },
                allowTouchMove:false,
                loop: true,
                loopedSlides:10,
                loopAdditionalSlides: 1,
                parallax: true,
                simulateTouch: false,
            });
            const pagination = slider.querySelector('.default-slider__pagination');
            let swiper = new Swiper(slider, {
                slidesPerView: 'auto',   
                loop: true,
                speed: SPEED,
                simulateTouch: false,
                autoplay: {
                    delay: AUTOPLAYSPEED,
                    autoplayDisableOnInteraction: false,
                    disableOnInteraction: false,
                },
                loopedSlides: 10,
                loopAdditionalSlides: 1,
                touchStartPreventDefault: false,
                watchSlidesVisibility: true,
                pagination: pag(pagination),
                watchSlidesProgress: false,
                controller: {
                    control: left
                },
                navigation: {
                    nextEl: '[next-slide]'
                },

                on: {
                    transitionStart(swiper){
                        if (!isDesktop()) {return } 
                        
                            const img = swiper.slides[swiper.activeIndex].querySelector('img')
                            const prevImg =  swiper.slides[swiper.previousIndex].querySelector('img')
                            gsap.to(img,{
                                scale: 1.1,
                                duration: 1,
                                delay: 1,
                                ease: 'Power1.inOut'
                            })
                            gsap.to(prevImg,{
                                scale: 1.2,
                                duration: 0,
                                delay: 2
                            })
                        
                    },        
                }, 
                breakpoints: {
                    0: {
                        centeredSlides: true,
                        spaceBetween: 14
                    },
                    768: {
                        centeredSlides: true,
                        spaceBetween: 44
                    },
                    1025: {
                        centeredSlides: false,
                        spaceBetween: 0, 
                    }
                }
                
            });
            
            startAutoplay(swiper, slider);
        })

    //#endregion

    //#region FULL-WIDTH-IMG-VIDEO
        const fullImgVideo = document.querySelectorAll('[img-video-full-slider]');

        fullImgVideo.forEach(slider =>{
            const pagination = slider.querySelector('.default-slider__pagination');
            
            let sw = new Swiper(slider, {
                loop: true,
                speed:SPEED,
                parallax:true,
                autoplay: {
                    delay: AUTOPLAYSPEED,
                    autoplayDisableOnInteraction: false,
                    disableOnInteraction: false,
                },
                touchStartPreventDefault: false,
                loopAdditionalSlides: 10,
                on: {
                    init: function(){
                        this.autoplay.stop();
                    },
                    imagesReady: function(){
                    
                        this.autoplay.start();
                    }
                },
                navigation: {
                    nextEl: '.next',
                    prevEl: '.prev',
                },
                pagination: pag(pagination),
                
            });           
            startAutoplay(sw, slider)

            const videos = slider.querySelectorAll('video');

            videos.length> 0? videoHandle():false;

            function videoHandle(){
            
                videos.forEach(video =>{
                    const player = new Plyr(video, {
                        hideControls: false,
                        controls: ['progress'],
                        muted: true,
                        autoplay: true,
                        autopause: false,
                        invertTime: false,
                        displayDuration: false,
                        loop: {
                            active: true
                        },
                        vimeo: {
                            loop: true,
                            muted: true,
                        }
                        
                    });
                    player.on('play', ()=>{
                        player.muted = true
                    })
                    sw.on('slideChange', (e)=>{
                        if (sw.slides[sw.activeIndex].querySelector('video') == video){
                           player.play();
                        } else {
                            player.pause();
                        }
                    })                    
                })
            }
        })
    //#endregion

    //#region COURSES SLIDER
        const coursesSlider = document.querySelectorAll('[courses-slider]');
            
        coursesSlider.forEach(slider =>{
            const pagination = slider.querySelector('.default-slider__pagination');
            let swiper = new Swiper(slider, {
                slidesPerView: 'auto',
                resistanceRatio: 0,
                centeredSlides: true,
                loop: false,
                speed: 600,
                initialSlide: 1,
                autoplay: {
                    delay: AUTOPLAYSPEED,
                    autoplayDisableOnInteraction: false,
                    disableOnInteraction: false,
                },
                breakpoints: {
                    1025: {
                        simulateTouch:false,
                        allowTouchMove:false,
                        virtualTranslate: true,
                        spaceBetween: 0,
                        loop: false,
                    },
                    0: {
                        simulateTouch:true,
                        allowTouchMove:true,
                        virtualTranslate: false,
                        spaceBetween: 14,
                        loop: true,
                        nextEl : null,
                    },
                    768: {
                        virtualTranslate: true,
                        spaceBetween: 0,
                        loop: false,
                        nextEl : '.front-side',
                    }
                },
                watchSlidesProgress: true,
                
                effect: "cardTransition",
                touchStartPreventDefault: false,
                pagination: pag(pagination),
                on: {
                    setTransition(swiper, transition) {
                        if (isMobile()) {
                            return
                        }
                        setTransition(swiper, transition);
                    },
                    setTranslate(swiper, translate) {
                        if (isMobile()) {
                            return
                        }
                        setTranslate(this, translate);
                    }
                }
            });

            paginationClass(slider, swiper);

            let currentTransitionSpeed = 0, rotateInSeconds = 0;

            function setTransition(swiper, transitionSpeed) {
                currentTransitionSpeed = transitionSpeed;
            }

            function getTransitionSpeed() {
                const transitionSpeed = currentTransitionSpeed;
                currentTransitionSpeed = 0;
                return transitionSpeed;
            }

            function setTranslate(swiper, wrapperTranslate) {
                rotateInSeconds = getTransitionSpeed() / 1000;
                const slides = Object.values(swiper.slides);
                slides.map((slide, index) => {
                    const frontCard = slide.querySelector(".front-side");
                    const backCard = slide.querySelector(".back-side");
                    gsap.set(backCard, {rotationY:-180});
                    let shiftX, shiftY;

                    const offset = slide.swiperSlideOffset;
                    let x = -offset;
                    let y = 0;
                    if (isTablet()){
                        shiftX = 60;
                        shiftY = 25;
                    } else {
                        shiftX = 220;
                        shiftY = 25;
                    }
                    

                    let progress = slide.progress;
                    slide.setAttribute('progress', slide.progress)
                    if ( Math.abs(progress) >= 0 && Math.abs(progress) < 1 )  {
                        slide.classList.add("is-front");
                        x -= progress * shiftX;
                        y -= Math.abs(progress) * shiftY;

                    } 

                    else if((progress >= 1 && progress < 2)  || (progress <= -2 )){
                        x -= shiftX + Math.abs(progress % 1.001);
                        y -= shiftY;
                        slide.classList.remove('next');
                        slide.classList.add('prev');
                    }
                    else if((progress <= -1 && progress > -2)  || (progress >= -2 )){
                        x += shiftX + Math.abs(progress % 1.001);
                        y +=shiftY;
                        slide.classList.remove('prev');
                        slide.classList.add('next');
                        
                       
                    }
                    if (progress == 0){
                        gsap.to(backCard, {rotationY: 0, duration: 1, delay: 0});
                        gsap.to(frontCard, {rotationY: 180, duration: 1, delay: 0});
                    } else {
                        gsap.to(backCard, {rotationY: -180, duration: 1, delay: 0});
                        gsap.to(frontCard, {rotationY: 0, duration: 1, delay: 0});
                    }   

                    gsap.to(slide, {
                        x: x,
                        y: y,
                        duration: rotateInSeconds,
                    });
   
                }); 
            }

            const nextButtons = slider.querySelectorAll("[next-el]");

            nextButtons.forEach(nextBtn =>{
                nextBtn.addEventListener("click", function () {
                    let next = swiper.activeIndex + 1;
                    if (next == swiper.slides.length) {
                        next = 0;
                    }
                    swiper.slideTo(next);
                })
            })
        })

    //#endregion

}